export default __webpack_public_path__ + "static/media/services_less_3_5t.4145332e.svg";